import { render, staticRenderFns } from "./SSelectProducer.vue?vue&type=template&id=5761c687"
import script from "./SSelectProducer.vue?vue&type=script&lang=js"
export * from "./SSelectProducer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports